// extracted by mini-css-extract-plugin
module.exports = {"confirmList":"Confirm_confirmList_1LWBB","itemname":"Confirm_itemname_1E0sB","detail":"Confirm_detail_3xfE7","btns":"Confirm_btns_1TcJo"};